import MenuCategories from './MenuCategories'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { changeSelectedCategory } from '../../../store/actions/public'
import * as publicSelectors from '../../../selectors/public'

const mapStateToProps = state => ({
  categories: publicSelectors.getCurrentCategories(state),
  selectedCategoryId: publicSelectors.getSelectedCategoryId(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ changeSelectedCategory }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(MenuCategories)



// WEBPACK FOOTER //
// ./src/modules/Menu/MenuCategories/index.js